import React from 'react'
import { ShowIf } from '@ztechapps/webui.util'
import { BusyButton } from '@ztechapps/webui.button'
import { useCanCancelOrder, useCancelOrder } from '@ztechapps/order.common'
import { useConfirmDialog, useError } from '@ztechapps/common.hook'
import type { Order } from '@ztechapps/common.contract'

export const CancelOrderButton = ({ document }: { document?: Order }) => {
  const { _id, status } = document ?? {}

  const [cancelOrder, { loading, error }] = useCancelOrder({ orderId: _id, status })
  useError(error)
  const canCancel = useCanCancelOrder({ orderId: _id })
  const { confirm } = useConfirmDialog({
    title: 'Cancel order?',
    text: 'This will fully refund all payments, void the shipping. You cannot do any changes with this order once it is cancelled.',
  })
  const onClick = async () => {
    await confirm(async () => {
      await cancelOrder()
    })
  }
  return (
    <ShowIf condition={canCancel}>
      <BusyButton icon="thumbs-down" text="Cancel" title="Cancel this order" onClick={onClick} isBusy={loading} />
    </ShowIf>
  )
}
